import { create } from 'zustand';
import type { StripAnalyzeRequest } from './types';

interface State {
  request: StripAnalyzeRequest;
  setSection: (p: Partial<StripAnalyzeRequest['section']>) => void;
  setMaterials: (p: Partial<StripAnalyzeRequest['materials']>) => void;
  setSoil: (p: Partial<StripAnalyzeRequest['soil']>) => void;
  setLoads: (p: Partial<StripAnalyzeRequest['loads']>) => void;
  setReinforcement: (p: Partial<StripAnalyzeRequest['reinforcement']>) => void;
  loadRequest: (req: StripAnalyzeRequest) => void;
}

const defaultRequest: StripAnalyzeRequest = {
  section: { B: 80, Hf: 50, tw: 15, df: 120 },
  materials: { fc: 210, fy: 4200, cover: 7.5 },
  soil: { sigma_adm: 1.0, gamma_s: 1800, gamma_c: 2400, sigma_factor: 1.0 },
  loads: { P_per_m: 8000, M_per_m: 0, Pu_per_m: 12_000, Mu_per_m: 0 },
  reinforcement: { diam_main: '1/2', s_main: 20, diam_dist: '3/8', s_dist: 25 },
};

export const useStripStore = create<State>((set) => ({
  request: defaultRequest,
  setSection: (p) => set((s) => ({ request: { ...s.request, section: { ...s.request.section, ...p } } })),
  setMaterials: (p) => set((s) => ({ request: { ...s.request, materials: { ...s.request.materials, ...p } } })),
  setSoil: (p) => set((s) => ({ request: { ...s.request, soil: { ...s.request.soil, ...p } } })),
  setLoads: (p) => set((s) => ({ request: { ...s.request, loads: { ...s.request.loads, ...p } } })),
  setReinforcement: (p) => set((s) => ({ request: { ...s.request, reinforcement: { ...s.request.reinforcement, ...p } } })),
  loadRequest: (req) => set({ request: req }),
}));
